<template>
  <div v-if="loading" class="text-center mt-5 font-2xl text-muted">
    <i class="fal fa-spinner fa-spin" /> Sample Data Loading...
  </div>
  <div v-else class="animated fadeIn">
    <basic-heading :title="`${sample_type.name} Details`" class="mb-3">
      <template #right-content>
        <header-button-group :button_config="button_config">
          <template #post_buttons>
            <button
              v-show="checkPermission('delete sample type')"
              title="Delete sample type"
              class="btn btn-danger ml-1"
              @click="showDeleteModal"
            >
              <i class="fal fa-trash" />
            </button>
          </template>
        </header-button-group>
      </template>
    </basic-heading>
    <permission-alert-gate :permissions="'read sample type'">
      <template #gated-content>
        <sample-type-card :sample_type="sample_type" />
        <sample-type-detail-cardstack :sample_type="sample_type" />
      </template>
    </permission-alert-gate>
  </div>
</template>

<script>
import Vue from "vue";
import VueNotifications from "vue-notifications";
import BasicHeading from "@/components/shared/BasicHeading";
import HeaderButtonGroup from "@/components/shared/headerbuttons/HeaderButtonGroup";
import PermissionAlertGate from "@/components/permission/PermissionAlertGate";
import SampleTypeCard from "@/components/lab/sampletype/SampleTypeCard";
import SampleTypeDetailCardstack from "@/components/lab/sampletype/SampleTypeDetailCardstack";
import { AccessControlCheck } from "@/auth/AccessControlCheck";
import { LabRepositoryFactory } from "@/repositories/lab/LabRepositoryFactory";
import { notificationOptions } from "@/shared/toast-notification-options";
import { sampleTypeNotifications } from "@/shared/notifications";
import { getModel } from "@/shared/fetch-utils";

const SampleTypeRepository = LabRepositoryFactory.get("sampleType");

Vue.use(VueNotifications, notificationOptions);

export default {
  name: "SampleTypeDetail",
  components: {
    BasicHeading,
    HeaderButtonGroup,
    PermissionAlertGate,
    SampleTypeCard,
    SampleTypeDetailCardstack,
  },
  data() {
    return {
      loading: true,
      laboratory_id: this.$store.getters.getLaboratoryContext.id || null,
      sample_type_id: this.$route.params.sample_type_id || null,
      sample_type: null,
    };
  },
  computed: {
    button_config() {
      return {
        buttons: [
          {
            icon: "fa-list",
            linkto: "/sampletypes",
            title: "Sample type list",
          },
          {
            icon: "fa-pencil",
            linkto: `/sampletypes/${this.sample_type_id}/edit`,
            title: "Edit sample type",
            variant: "warning",
            permission: this.checkPermission("edit sample type"),
          },
        ],
        dropdown: {
          items: [
            {
              text: "Update Service Instructions",
              linkto: `/sampletypes/${this.sample_type_id}/instructions/update`,
            },
            {
              text: "Update Service Questions",
              linkto: `/laboratory/${this.laboratory_id}/service-questions/update/${this.sample_type_id}`,
            },
            {
              icon: "fa-chart-bar",
              linkto: `/sampletypes/${this.sample_type_id}/analyte-range`,
              text: "Analyte Ranges",
              variant: "info",
            }
          ],
        },
      };
    },
  },
  methods: {
    checkPermission(permission) {
      return AccessControlCheck.checkPermission(permission);
    },
    showDeleteModal() {
      this.$bvModal
        .msgBoxConfirm(
          "You are about to remove this sample type. Do you want to continue?",
          {
            title: "Are you sure?",
            modalClass: ["modal-danger"],
            size: "sm",
            okVariant: "danger",
            okTitle: "YES",
            cancelTitle: "NO",
            footerClass: "p-2",
            centered: true,
          }
        )
        .then(async (confirm) => {
          if (confirm) {
            try {
              await SampleTypeRepository.suspend(
                this.sample_type_id
              );

              this.deleteSuccess();
                this.$router.push("/sampletypes");
            } catch ({ response }) {
              const { status, data } = response.response;
  
              this.$bvToast.toast(`Code: ${status}. ${data.error}`, {
                title: "Server Error.",
                variant: "danger",
              });
            }
          }
        });
    },
  },
  async created() {
    this.loading = true;

    this.sample_type = await getModel({
      model_type: "sample_type",
      id: this.sample_type_id,
      message: this.$bvToast,
    });

    this.sample_type ? (this.loading = false) : this.$router.back();
  },
  notifications: sampleTypeNotifications,
};
</script>
